export const TYPE_ADOBE_ANALYTICS = 'adobe_analytics';
export const TYPE_GOOGLE_ANALYTICS = 'google_analytics';
const TYPE_GOOGLE_DATA_STUDIO = 'google_data_studio';
export const TYPE_GOOGLE_SEARCH_CONSOLE = 'google_search_console';

const TYPES = [
	TYPE_ADOBE_ANALYTICS,
	TYPE_GOOGLE_ANALYTICS,
	TYPE_GOOGLE_DATA_STUDIO,
	TYPE_GOOGLE_SEARCH_CONSOLE,
];



function validateType(type) {
	if (!TYPES.includes(type)) {
		throw new Error('Integration type \'' + type + '\' is not supported. Supported values are: ' + TYPES.join(','));
	}
}



export function getIntegrationByType({ type, website }) {
	validateType(type);

	return website
		.get('integrations')
		.find((integration) => integration.get('type') === type);
}
